"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var api_exports = {};
__export(api_exports, {
  Api: () => Api
});
module.exports = __toCommonJS(api_exports);
var import_basket = require("./api/basket");
var import_catalog = require("./api/catalog");
var import_checkout = require("./api/checkout");
var import_coupon = require("./api/coupon");
var import_customer = require("./api/customer");
var import_general = require("./api/general");
var import_indexer = require("./api/indexer");
var import_newsletter = require("./api/newsletter");
var import_translate = require("./api/translate");
var import_wishlist = require("./api/wishlist");
var Api;
((Api2) => {
  Api2.Basket = import_basket.Basket;
  Api2.Catalog = import_catalog.Catalog;
  Api2.Customer = import_customer.Customer;
  Api2.Checkout = import_checkout.Checkout;
  Api2.Coupon = import_coupon.Coupon;
  Api2.General = import_general.General;
  Api2.Indexer = import_indexer.Indexer;
  Api2.Newsletter = import_newsletter.Newsletter;
  Api2.Translate = import_translate.Translate;
  Api2.Wishlist = import_wishlist.Wishlist;
})(Api || (Api = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Api
});
